import React from "react";
import "./error.css";

const NotFound = () => {
  const errorImg = "https://shots.codepen.io/RishabhMishra/pen/wvwrpKL-1280.jpg?version=1567484579";
  return (
    <div className="notFound-wrapper-box">
      <img src={errorImg} alt="err" />
    </div>
  );
};

export default NotFound;


